<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="active_step" rules="required" v-slot="{valid, errors}">
                        <b-form-group>
                            <b-form-select v-model="form.active_step" :options="options"></b-form-select>
                            <div class="invalid-feedback" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import ApprovalStepService from "@/services/ApprovalStepService";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,

    },
    props: {
        stepData:  {
        },
        activeStepId: {
            type: Number
        }
    },
    data() {
        return {
            formLoading: false,
            form: {
                active_step: null,
            },
            options: []
        }
    },
    watch: {
        activeStepId: {
            immediate: true,
            handler(value) {
                this.form.active_step = value;
            }
        },
        stepData: function (val) {
            this.options = val.map(item => ({
                value: item.id,
                text: this.getApproveText(item.rank),
            }));
        },
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.form.active_step) {
                this.formLoading = true;

                ApprovalStepService.setActive(this.form.active_step)
                    .then((response) => {
                        this.formLoading=false;
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("approvalStepFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    })
            }
        },
        getApproveText(rank) {
            if (rank === 1) {
                return this.$t("coordinator_approval");
            }
            if (rank === 2) {
                return this.$t("institute_approval");
            }
            if (rank === 3) {
                return this.$t("advisor_approval");
            }

            return "-";
        },
    }
}
</script>
